import React from 'react'
import { Modal, List } from 'antd'

const BatchConfirmModal = ({ visible, onCancel, onOk, pendingEdits = {} }) => {
  return (
    <Modal
      maskClosable={false}
      visible={visible}
      title="Confirm Batch Generation"
      onCancel={onCancel}
      onOk={onOk}
      okText="Start Generation"
      cancelText="Cancel"
      centered
      width={600}
    >
      <p style={{ marginBottom: 12 }}>
        You are about to generate images for the following{' '}
        <strong>{Object.keys(pendingEdits).length}</strong> location(s):
      </p>
      <div
        style={{
          maxHeight: '300px',
          overflowY: 'auto',
          background: '#f5f5f5',
          padding: '12px',
          borderRadius: '4px',
          border: '1px solid #e8e8e8'
        }}
      >
        <List
          size="small"
          dataSource={Object.keys(pendingEdits)}
          renderItem={key => (
            <List.Item style={{ padding: '8px 0' }}>
              <div style={{ width: '100%' }}>
                <div style={{ fontWeight: 600 }}>{key}</div>
                <div style={{ fontSize: '12px', color: '#666', marginTop: 4 }}>
                  {pendingEdits[key]}
                </div>
              </div>
            </List.Item>
          )}
        />
      </div>
      <p style={{ marginTop: 12, color: '#888', fontSize: '12px' }}>
        This triggers a batch process. Please wait while the images are
        generated.
      </p>
    </Modal>
  )
}

export default BatchConfirmModal
